export const lightPrimary = {
  contrast: '#fff',
  light: '#F9EFE7',
  dark: '#815F52',
  main: '#000000',
  borders: '#E1C7B2',
  hoverOutlined: '#F1E6DC',
};

export const lightSecondary = {
  contrast: '#F9EFE7',
  dark: '#5E4037',
  light: '#E1C7B2',
  main: '#CDA17F',
};

export const lightError = {
  contrast: '#FEE9E5',
  dark: '#DD3F33',
  light: '#F6958F',
  main: '#DD3F33',
};

export const lightWarning = {
  contrast: '#ffffff',
  dark: '#CE7F08',
  light: '#FDF5DD',
  main: '#CE7F08',
  secondary: '#D69D61',
};

export const lightInfo = {
  contrast: '#ffffff',
  dark: '#6175B3',
  light: '#DFEBF7',
  main: '#6175B3',
};

export const lightSuccess = {
  contrast: '#ffffff',
  dark: '#1F9464',
  light: '#E1F7EC',
  main: '#1F9464',
};

export const lightBackground = {
  default: '#FDFDFC',
  paper: '#FDFDFC',
};

export const lightText = {
  primary: '#000000',
  secondary: '#8A8B87',
};

export const lightNeutral = {
  100: '#FFFEFC',
  200: '#F1E6DC',
  300: '#ECE6E2',
  400: '#E3D7D2',
  500: '#CCC3B7',
  600: '#ACACAC',
  700: '#8A8B87',
  800: '#61635B',
};

export const lightActions = {
  focus: '#E1C7B2',
  active: '#CCC1B7',
  hover: '#F1E6DC',
  selected: '#F1E6DC',
  disabled: '#AEAEAE',
  disabledBackground: '#ECE6E2',
};

export const darkPrimary = {
  contrast: '#111318',
  dark: '#ffffff',
  light: '#182027',
  main: '#EDEDED',
  borders: '#548697',
  hoverOutlined: '#6EBAD3',
};

export const darkSecondary = {
  contrast: '#ffffff',
  dark: '#3e4b54',
  light: '#7992a2',
  main: '#506176',
};

export const darkError = {
  contrast: '#ffffff',
  dark: '#A53531',
  light: '#EF6F6B',
  main: '#F97066',
};

export const darkWarning = {
  contrast: '#ffffff',
  dark: '#975B1E',
  light: '#E09B55',
  main: '#FDB022',
  secondary: '#D69D61',
};

export const darkInfo = {
  contrast: '#ffffff',
  dark: '#0B4E8D',
  light: '#3F8CD4',
  main: '#4190DB',
};

export const darkSuccess = {
  contrast: '#ffffff',
  dark: '#3B873E',
  light: '#7BC67E',
  main: '#27AB6E',
};

export const darkBackground = {
  default: '#111318',
  paper: '#111318',
};

export const darkText = {
  primary: '#EDEDED',
  secondary: '#A0A19B',
};

export const darkNeutral = {
  100: '#182027',
  200: '#434342',
  300: '#626261',
  400: '#B7BDCC',
  500: '#323232',
  600: '#7C85A2',
  700: '#3F455A',
  800: '#2A2F3C',
  900: '#1E212A',
};

export const darkActions = {
  focus: '#2c414b',
  active: '#EDEDED',
  hover: '#182027',
  selected: 'rgba(33, 40, 49, 0.08)',
  disabled: '#535353',
  disabledBackground: '#242424',
};

export const approvedStatus = {
  approved: '#27AB6E',
  notApproved: '#538ACE',
};

export const lightRemovalNotification = {
  main: 'rgba(240, 68, 56, 0.02)',
};

export const darkRemovalNotification = {
  main: 'rgba(240, 68, 56, 0.07)',
};

export const lightErrorIndicator = {
  main: 'rgba(240, 68, 56, 0.02)',
  dark: '#DD3F33',
};

export const darkErrorIndicator = {
  main: 'rgba(240, 68, 56, 0.07)',
  dark: '#BB4A42',
};

export const darkPickersSelectedBackground = {
  main: '#19252C',
};

export const lightPickersToday = {
  // border: '#DDEFF5',
  border: '#E1C7B2',
};

export const darkPickersToday = {
  border: '#324453',
};

export const rememberHighlight = {
  main: '#B54708',
  dark: '#BB4A42',
  background: 'rgba(240, 68, 56, 0.02)',
  darkBackground: 'rgba(240, 68, 56, 0.07)',
  border: 'rgba(240, 68, 56, 0.4)',
  darkBorder: 'rgba(187, 74, 66, 0.7)',
};

export const assetsBackground = {
  light: '#EAE9E9',
  dark: '#474545',
};

export const status = {
  success: '#1F9464',
  pending: '#CE7F08',
  error: '#DD3F33',
  info: '#6175B3',
};

export const tableRowWithErrorBackground = {
  light: '#F0443805',
  dark: '#F0443812',
};
